import { computed, inject, Injectable, signal } from '@angular/core';
import { sortBy } from '@softline/core';
import { PageFilterService } from './page-filter.service';
import { PageFilterGroup } from '../types/page-filter-group';
import { PageFilterItem } from '../types/page-filter-item';

@Injectable()
export class PageFilterListService {

  service = inject(PageFilterService);

  search = signal('');

  list = computed(() => {
      const groups = sortBy(this.service.groups, 'order');
      const items = this.filterBySearch(sortBy(this.service.items, 'order'));
      const searching = this.search().trim().length > 0;

      const returnValue = groups.map(group => {
        return {
          group: group as PageFilterGroup | null,
          items: items.filter(item => item.groupKey === group.key)
        }
      })
    returnValue.push({group: null, items: items.filter(item => !item.groupKey)})
    if(searching)
      return returnValue.filter(o => o.items.length > 0);
    return returnValue;
    });

  private filterBySearch(items: PageFilterItem<any, any>[]): PageFilterItem<any, any>[] {
    const search = this.search().trim().toLowerCase();
    if(!search)
      return items;
    return items.filter(item => `${item.config.title()}`.toLowerCase().includes(search));
  }
}
